<template>
    <div class="addBtn">
        <div class="btn" @click="$router.push(path)">
            +{{name}}
        </div>
    </div>
</template>
<script>
export default {
    name: "AddBtn",
    props:['name','path']
}
</script>
<style scoped lang="less">
.addBtn {
    height: 32px;
    margin-bottom: 20px;
    .btn {
        float: right;
        width: 150px;
        height: 32px;
        background-color: #3D90F6;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
    }
}
</style>